var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { gql, useMutation } from '@apollo/client';
import { DateTime } from 'luxon';
import { SwapTermsModalContent } from '.';
import { SwapFlowModalContentTypes } from '../SwapFlowModalFeature/SwapFlowModalTypes';
import { logger } from '@amzn/atoz-shiftapp-metrics';
import { BIAnalytics } from '@amzn/atoz-shiftapp-utilities';
export var SwapTermsModalContentFeature = function (_a) {
    var originalShift = _a.originalShift, currentSelectedDays = _a.currentSelectedDays, siteSwapConfiguration = _a.siteSwapConfiguration, setModalContent = _a.setModalContent, setModalError = _a.setModalError, employeeId = _a.employeeId, close = _a.close, allScheduleDaysForDay = _a.allScheduleDaysForDay;
    var selectedSwapRequestDays = currentSelectedDays.map(function (swap) {
        return swap.toISODate();
    });
    var swapFromDateISO = DateTime.fromISO(originalShift.date).toISO();
    var _b = React.useState(false), hasErrors = _b[0], setHasErrors = _b[1];
    var _c = React.useState(false), isSuccessful = _c[0], setIsSuccessful = _c[1];
    var _d = React.useState(false), submitting = _d[0], setSubmitting = _d[1];
    var onCreateSwap = useMutation(CREATE_SWAP_MUTATION)[0];
    React.useEffect(function () {
        if (hasErrors) {
            setModalContent(SwapFlowModalContentTypes.swapCreateError);
        }
    }, [hasErrors]);
    React.useEffect(function () {
        if (isSuccessful) {
            setModalContent(SwapFlowModalContentTypes.swapCreateSuccess);
        }
    }, [isSuccessful]);
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setSubmitting(true);
                    return [4 /*yield*/, Promise.all(currentSelectedDays.map(function (swapDate) {
                            var createSwapInput = {
                                siteId: siteSwapConfiguration.siteId,
                                swapFrom: swapFromDateISO,
                                swapTo: swapDate.toISO()
                            };
                            return onCreateSwap({ variables: { createSwapInput: createSwapInput } });
                        }))];
                case 1:
                    _a.sent();
                    BIAnalytics.swapRequestSuccess(originalShift.date, selectedSwapRequestDays, employeeId, siteSwapConfiguration.siteId);
                    setIsSuccessful(true);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    logger.emitError('Issue creating swap request', {
                        error: new Error(error_1)
                    });
                    BIAnalytics.swapRequestFailure(originalShift.date, selectedSwapRequestDays, employeeId, siteSwapConfiguration.siteId);
                    setModalError(error_1);
                    setHasErrors(true);
                    return [3 /*break*/, 4];
                case 3:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var swapFromDateTime = React.useMemo(function () { return DateTime.fromISO(originalShift.date); }, [originalShift.date]);
    var swapToDateTime = selectedSwapRequestDays.length === 1
        ? DateTime.fromISO(selectedSwapRequestDays[0])
        : null;
    var hasMultipleShifts = allScheduleDaysForDay.length > 1;
    return (React.createElement(SwapTermsModalContent, { closeModal: close, onSubmitClick: function () {
            BIAnalytics.createSwapRequest(originalShift.date, selectedSwapRequestDays, employeeId, siteSwapConfiguration.siteId);
            handleSubmit();
        }, loading: submitting, swapFromDate: swapFromDateTime, swapToDate: swapToDateTime, hasMultipleShifts: hasMultipleShifts }));
};
export var CREATE_SWAP_MUTATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation CreateSwap($createSwapInput: CreateSwapInput!) {\n        createSwap(input: $createSwapInput) {\n            swapRequestId\n        }\n    }\n"], ["\n    mutation CreateSwap($createSwapInput: CreateSwapInput!) {\n        createSwap(input: $createSwapInput) {\n            swapRequestId\n        }\n    }\n"])));
SwapTermsModalContentFeature.fragments = {
    siteSwapConfiguration: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        fragment SwapTermsModalContentFeature_SiteSwapConfiguration on SiteSwapConfiguration {\n            siteId\n        }\n    "], ["\n        fragment SwapTermsModalContentFeature_SiteSwapConfiguration on SiteSwapConfiguration {\n            siteId\n        }\n    "]))),
    swapScheduleDay: gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        fragment SwapTermsModalContentFeature_SwapScheduleDay on SwapScheduleDay {\n            date\n        }\n    "], ["\n        fragment SwapTermsModalContentFeature_SwapScheduleDay on SwapScheduleDay {\n            date\n        }\n    "])))
};
var templateObject_1, templateObject_2, templateObject_3;
